
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"2 0 23 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3v4.59L7.59 15H3v6h6v-4.58L16.42 9H21V3m-4 2h2v2h-2M5 17h2v2H5","fill":"#515358"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/toolbars/pathInspector.svg